// src/twind.ts
import install from '@twind/with-react';
import config from './twind.config';

install(config);
